export default __webpack_public_path__ + "static/media/107_mobile.75c87d92.jpg";